import React, {useContext, useEffect, useRef, useState} from 'react';
import {Editor} from '@tinymce/tinymce-react';


const TinymceEditor = ({value, handleChange, height, onInit, dictionary}) =>
{
    const marker = `<span id="text-replacement-marker-element"></span>`
    const editorRef = useRef(null);
    const [html, setHtml] = useState('')

    useEffect(() => {
        if(value) {
            setHtml(value)
        }
        else {
            setHtml('')
        }
    }, [value]);

    function getFileAsBase64({accept})
    {
        return new Promise((resolve, reject) => {
            const input = document.createElement('input');
            input.type = 'file';
            input.id = 'file';
            input.accept = accept

            input.onchange = async (e) => {
                const file = input.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve({
                    data: reader.result.replace(new RegExp('data:.*/.*;base64,'), ''),
                    url: reader.result,
                    fileName: file.name
                });
                reader.onerror = error => reject(error);
            }

            input.click()
        })
    }

    // esef.berfu@hotmail.com
    return (
        <Editor
            onInit={(evt, editor) => {
                editorRef.current = editor;
                onInit && onInit(editor);
            }}
            initialValue={html}
            onEditorChange={(text) => {
                handleChange && handleChange(text)
            }}
            apiKey="ztoem8r8uck52zkq3rf8e80rml0cle6e7c1940p0gqzx9jn0"
            init={{
                height: height || '75vh',
                menubar: false,
                content_style: `body { color: #000; font-size: 11pt; line-height:1 }`,
                mobile: false,
                fontsize_formats: '8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt',
                statusbar: false,
                plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen media',
                    'insertdatetime media table code paste help wordcount table code codesample pagebreak'
                ],
                table_toolbar: "tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol",
                contextmenu: false,
                formats: {
                    bold:{inline: 'b'},
                    underline:{inline: 'u'},
                    italic:{inline: 'i'},
                },
                extended_valid_elements:'u,b,i,iframe[src|frameborder|style|scrolling|class|width|height|name|align]',
                valid_elements: "@[id|class|style|title|dir<ltr?rtl|lang|xml::lang|onclick|ondblclick|"
                    + "onmousedown|onmouseup|onmouseover|onmousemove|onmouseout|onkeypress|"
                    + "onkeydown|onkeyup],a[rel|rev|charset|hreflang|tabindex|accesskey|type|"
                    + "name|href|target|title|class|onfocus|onblur],b/strong,i/em,strike,u,"
                    + "#p,-ol[type|compact],-ul[type|compact],-li,br,img[longdesc|usemap|"
                    + "src|border|alt=|title|hspace|vspace|width|height|align],-sub,-sup,"
                    + "-blockquote,-table[border=0|cellspacing|cellpadding|width|frame|rules|"
                    + "height|align|summary|bgcolor|background|bordercolor],-tr[rowspan|width|"
                    + "height|align|valign|bgcolor|background|bordercolor],tbody,thead,tfoot,"
                    + "#td[colspan|rowspan|width|height|align|valign|bgcolor|background|bordercolor"
                    + "|scope],#th[colspan|rowspan|width|height|align|valign|scope],caption,-div,"
                    + "-span,-code,-pre,address,-h1,-h2,-h3,-h4,-h5,-h6,hr[size|noshade],-font[face"
                    + "|size|color],dd,dl,dt,cite,abbr,acronym,del[datetime|cite],ins[datetime|cite],"
                    + "object[classid|width|height|codebase|*],param[name|value|_value],embed[type|width"
                    + "|height|src|*],script[src|type],map[name],area[shape|coords|href|alt|target],bdo,"
                    + "button,col[align|char|charoff|span|valign|width],colgroup[align|char|charoff|span|"
                    + "valign|width],dfn,fieldset,form[action|accept|accept-charset|enctype|method],"
                    + "input[accept|alt|checked|disabled|maxlength|name|readonly|size|src|type|value],"
                    + "kbd,label[for],legend,noscript,optgroup[label|disabled],option[disabled|label|selected|value],"
                    + "q[cite],samp,select[disabled|multiple|name|size],small,"
                    + "textarea[cols|rows|disabled|name|readonly],tt,var,big",
                invalid_elements:'em strong',
                toolbar:
                    'styleselect | formats blockformats fontformatselect fontsizeselect align lineheight | bold italic bullist numlist image insert_image blockquote table media undo redo forecolor backcolor code codesample',
                theme_advanced_toolbar_align: 'center',
                table_default_attributes: {
                    border: '0',
                    align: 'center'
                },
                table_default_styles: {
                    width: '50%'
                },
                setup: (editor) => {
                    editor.ui.registry.addButton('insert_image', {
                        text: 'Image',
                        onAction: async (_) => {
                            const image = await getFileAsBase64({accept: '*'})
                            const imageHtml = `<img src="data:image/png;base64, ${image.data}" alt="Red dot" />
`
                            editor.insertContent(imageHtml);
                        }
                    })
                    editor.ui.registry.addButton('layout_12', {
                        text: '1x2',
                        onAction: function (_) {
                            const html = `
                                        <table style="width: 100%; border-style: none;" border="0" align="center">
                                        <tbody>
                                        <tr>
                                            <td style="width: 15%">Baslik</td>
                                            <td style="width: 34%">Icerik</td>
                                            <td style="width: 2%;"></td>
                                            <td style="width: 15%; text-align: right;">Baslik</td>
                                            <td style="width: 34%">Icerik</td>
                                        </tr>
                                        </tbody>
                                        </table>
                                        `
                            editor.insertContent(html);
                        }
                    });
                }
            }}
        />
    );
};

export default TinymceEditor;
